<template>
  <div class="top">
    <div class="top_box">
      <div class="top_left">
        <div :class="`title_icon top_left_symbol ${tlsymbol}`"></div>
        <h2 class="top_left_title">{{title}}</h2>
        <h2 class="top_left_title">{{wrap}}</h2>
        <p class="top_left_subtitle">{{subtitle}}</p>
        <div :class="`top_left_content_1 ${tlcontent1}`" v-if="content && typeof(content)==='string'">{{content}}</div>
        <div class="top_left_content_box" v-else-if="content && typeof(content)==='object'">
          <li v-for="(item, index) in content" :key="index" :class="`top_left_content ${tlcontent}`">
            <em></em>
            {{item.msg}}
          </li>
        </div>
        <!-- this.$emit('close') -->
        <A-Button v-if="operationBtnEvent" :text='btn' @onclick="operationBtn"></A-Button>
        <A-Button v-else :text='btn' @onclick="goLink(`https://platform.antdiy.vip/#/register?source=${source}`)"></A-Button>
      </div>
      <div class="top_right">
        <img :src="img" class="top_right_img" />
      </div>
    </div>
    <div :class='bg'></div>
  </div>
</template>

<script>
export default {
  name: 'topHP',
  props: ['title', 'subtitle', 'content', 'btn', 'img', 'bg', 'tlcontent', 'tlsymbol','wrap','tlcontent1','operationBtnEvent'],
  data () {
    return {
      pageList: [
        {name: 'Home', link: 'home'},
        {name: 'Services', link: 'services'},
        {name: 'Products', link: 'products'},
        {name: 'Blog', link: 'blog'},
        {name: 'Support', link: 'support'},
      ],
      source: localStorage.getItem('ant_source') || ''
    }
  },
  methods: {
    goLink (url) {
      window.open(url)
    },
    operationBtn(){
      this.$emit('operationBtn')
    }
  }
}
</script>

<style scoped>
  .top{
    width: 100%;
    background: #fff;
    overflow: hidden;
    position: relative;
  }
  .top_box{
    width: 1200px;
    margin: 0 auto 0;
    height: 480px;
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 1;
  }
  .top_left{
    width: 620px;
    padding-right: 40px;
  }
  .top_left_symbol{
    margin: 63px 0 21px;
  }
  .top_left_title{
    font-size: 32px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 40px;
  }
  .top_left_subtitle{
    font-size: 20px;
    font-family: Helvetica;
    color: #222536;
    line-height: 28px;
    margin: 24px 0;
  }
  .top_left_content_1{
    font-size: 16px;
    font-family: Helvetica;
    color: #8D919B;
    line-height: 24px;
    margin-bottom: 40px;
  }
  .top_left_content_box {
    margin-top: 22px;
  }
  .top_left_content > em {
    width: 10px;
    height: 10px;
    background: #fc5421;
    border-radius: 5px;
    margin-right: 10px;
    flex: 0 0 auto;
  }
  .top_right{
    width: 580px;
  }
  .top_right_img{
    width: 580px;
  }

  @media (max-width: 767px){
    .top {
      background-image: none !important;
    }
    .top_box{
      width: 100%;
      height: auto;
      padding: .96rem .46rem 1.15rem;
      flex-direction: column;
    }
    .top_left{
      width: 100%;
      padding: 0;
    }
    .top_left_symbol{
      margin: .77rem 0 .32rem;
    }
    .top_left_title{
      font-size: .42rem;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #222536;
      line-height: .58rem;
    }
    .top_left_subtitle{
      margin: .19rem 0 .32rem;
      font-size: .29rem;
      font-family: Helvetica;
      color: #222536;
      line-height: .4rem;
    }
    .top_left_content_1{
      font-size: .23rem;
      font-family: Helvetica;
      color: #8D919B;
      line-height: .35rem;
      margin-bottom: .19rem;
    }
    .top_left_content_box {
      margin-top: 0;
    }
    .top_left_content > em {
      width: 0.12rem;
      height: 0.12rem;
      background: #fc5421;
      border-radius: 0.06rem;
      margin-right: 0.1rem;
      flex: 0 0 auto;
    }
    .ad_button{
      width: 100%;
      text-align: center;
      border-radius: 6px;
    }
    .top_right{
      display: block;
      width: 100%;
      height: auto;
      margin-top: .38rem;
    }
    .top_right > img{
      width: 100%;
      border-radius: 6px;
    }
    .top_bg{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/topHP.vue